var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"img"},[_c('van-image',{attrs:{"src":_vm.itemData.imageUrl + '?x-oss-process=image/resize,w_750/quality,q_80'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }